import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ClientProfile } from '../../../models/client/client-profile.model';
import { ClientProfileService } from '../../../services/client-profile/client-profile.service';
import { AuthService } from '../../auth/services/auth.service';
import { navigationItems } from '../navigation-items';
import { MessagesService } from '../../../services/messages/messages.service';
import { MatDialog } from '@angular/material/dialog';
import { TwofaReminderDialogComponent } from '../twofa-reminder-dialog/twofa-reminder-dialog.component';

@Component({
  selector: 'aum-cli-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnDestroy {
  navigationItems = navigationItems;
  client: ClientProfile;
  currentDate = new Date().getTime() / 1000;
  parentUrl: string;
  previousRoute: string;
  title: string;
  unreadMessagesSub: Subscription;
  clientDetailsSub: Subscription;
  hasUnreadMessages = false;

  constructor(
    public authService: AuthService,
    private clientProfileService: ClientProfileService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    private messagesService: MessagesService,
    private dialog: MatDialog
  ) {
    router.events.subscribe(
      event => event instanceof ActivationEnd && this.handleRouteChange(event)
    );
  }

  handleRouteChange(event) {
    if (event.snapshot.data.routeData) {
      this.previousRoute = event.snapshot.data.routeData.previousRoute;
      this.title = event.snapshot.data.routeData.title;
    }
  }

  ngOnInit() {
    this.getClientData();
    this.getClientDetails();
    this.messagesService.countUnreadMessages();
    this.subscribeToMessagesCount();
  }

  subscribeToMessagesCount() {
    this.unreadMessagesSub = this.messagesService.hasUnreadMessagesChanges.subscribe(
      res => {
        this.hasUnreadMessages = res;
      }
    );
  }

  logout() {
    this.authService.logout();
  }

  getClientData() {
    this.clientProfileService.getData().subscribe(response => {
      this.client = response.body;
      this.clientProfileService.clientDetails.next(response.body);
      if (this.client) {
        localStorage.setItem('language', this.client.language.toLowerCase());
        this.maybeShowTwofaReminder();
      }
    });
  }

  getClientDetails() {
    this.clientDetailsSub = this.clientProfileService.clientDetails.subscribe(
      response => {
        if (response) {
          this.client = response;
        }
      }
    );
  }

  createParentUrl(): string {
    return (this.parentUrl =
      '/' + this.activeRouter?.firstChild?.routeConfig?.path);
  }

  ngOnDestroy() {
    if (this.unreadMessagesSub) {
      this.unreadMessagesSub.unsubscribe();
    }
    if (this.clientDetailsSub) {
      this.clientDetailsSub.unsubscribe();
    }
  }

  private maybeShowTwofaReminder() {
    if (!this.client) return;

    const has2fa =
      this.client.sms2FALoginEnabled ||
      this.client.email2FALoginEnabled ||
      this.client.totp2FALoginEnabled;

    // only if none enabled, not already shown this session,
    // and not on the security page already
    if (has2fa || this.router.url.startsWith('/settings/security-settings')) {
      return;
    }

    const ref = this.dialog.open(TwofaReminderDialogComponent, {
      panelClass: 'aum-glass-dialog',
      backdropClass: 'aum-dimmed-backdrop',
      disableClose: true
    });

    ref.afterClosed().subscribe(result => {
      sessionStorage.setItem('twofa_reminder_shown', 'true');
      if (result === 'activate') {
        this.router.navigate(['/settings/security-settings']);
      }
    });
  }
}
